import React,{useRef, useState, useEffect} from "react";
import { Select, Form, Card, Spinner} from "react-bootstrap";
import DialogLayerLibrary from "../layouts/DialogOwner";
import vindrApi from "../utils/vindrapi";

class LayerUpload extends React.Component {

	
	
	constructor(props) {
		
		super(props);

		this.feedback = {

		};
		
		this.state = {
			status: {sent:null, message:''}
		};
		
	}
	
	updateStatus(s){
		var x = {...this.state};
		x.status = s;
		this.setState(x);
		this.forceUpdate();
	}


	async handleChange(e){

	};
	handleDrop(ev){
		ev.preventDefault();
		if (ev.dataTransfer.items) {
			[...ev.dataTransfer.items].forEach((item, i) => {
				if (item.kind === "file") {
					const file = item.getAsFile();
					this.handleFile(file);
				}
			});
		} else {
		  // Use DataTransfer interface to access the file(s)
		  [...ev.dataTransfer.files].forEach((file, i) => {
			  this.handleFile(file);
		  });
		}
	}

	handleDrag(e){
		

	}
	handleBrowse(e){
		const file = e.target.files[0];
		this.handleFile(file);
	}
	getFileContent(file){
		const reader = new FileReader();
		reader.readAsText(file);
		reader.onload = (e) => this.handleFileContent(e, reader.result);
		reader.onerror = (err) => this.handleError(err);
	}
	handleFileContent(e, content){
		
		
	}
	handleFile(file){
		const formData = new FormData();
		formData.append('file', file);
		
		if(this.props.type == 'uploadFile'){
			formData.append('username', this.props.user.userDetails);
			formData.append('country', this.props.country);
		}
		
		this.updateStatus({sent:false, success:false, message:'Uploading...'});

		vindrApi[this.props.type ? this.props.type : 'uploadFile'](formData).then((response)=>{
			if(response.id || Array.isArray(response) || response.features){
				this.updateStatus({sent:true, success:true, message:'Your file was uploaded'});

				if(this.props.onUpload)
					this.props.onUpload(response);
			}
			else
				this.updateStatus({sent:true, success:false, message:'Error uploading file'});

		}).catch((e)=>{
			this.updateStatus({sent:true, success:false, message:'Error uploading file'});
		});
	}
	handleError(err){
		
	}

	render() {
		return (
			<Card className="layer-upload-card m-2">
				<h6>Upload your layer</h6>
				<div id="drop_zone" className="layer-upload-dropzone" onDrop={(e)=>this.handleDrop(e)} onDragOver={(e)=>this.handleDrag(e)}>
					{this.state.status.sent === null && 
						<>
							<i className="ri-upload-2-line"></i>
							<br />
							<span>
								Drag and drop or <b>browse.</b>
								<br />
								<small>({this.props.type == 'uploadFile' ? 'zipped shape, GeoJSON, Geopackage, dxf, txt' : 'Shape, GeoJSON, GPKG, CSV'})</small>
							</span>
							<input type="file" name="layer-upload-file" onChange={(e)=>this.handleBrowse(e)} />
						</>
					}
					{this.state.status.sent !== null && 
						<>
							{
							this.state.status.sent ?
								(this.state.status.success ? 
									(<i className="ri-checkbox-circle-line text-success"></i>)
									:
									(<i className="ri-error-warning-line text-warning"></i>)
								)
								:
								(<Spinner animation="border" variant="info" className="mt-5" />)
							}
							<br />
							<span>
								{this.state.status.message}
							</span>
						</>
					}
				</div>
			</Card>
		);
	}
}

export default LayerUpload;